export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./winning-stats.vue?vue&type=template&id=049cc4c3&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/winning-stats.vue?vue&type=template&id=049cc4c3&scoped=true
// module id = vC9x
// module chunks = 0